import React, { useState } from "react";
import BCreditRiskTracker from "../BusinessCreditScore/BCreditRiskTracker";
import PaydexScore from "./PaydexScore";
import CreditSummaryReportInquery from "./CreditSummaryReportInquery";
import CreditSummaryCommentary from "./CreditSummaryCommentary";
import CreditSummaryAccordions from "./CreditSummaryAccordions";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";
import * as services from "../../../store/service";
import ReactDOMServer from "react-dom/server";
import PrintBusinessCreditReport from "./PrintBusinessCreditReport";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

interface IProps {
    bCreditReportData: IBusinessCreditReportResponse;
    reportObject: BusinessCreditReportStatePII;
    isForPrinting?: boolean;
    requestBusinessCreditReport?: any;
    isPrintAndRefreshButtonShow?: boolean;
    creditProvider: string;
    isFromDailog?: boolean;
}
const CreditSummary: React.FunctionComponent<IProps> = (props) => {
    const [loading, setLoading] = useState(false);
    const [showAsAccordion, setShowAsAccordion] = useState(!props.isForPrinting);
    const showPreviousReport = props.bCreditReportData?.uiData?.previousDate ? true : false;

    const printCreditReport = () => {
        let themeCSS = "";
        const htmlMarkup = ReactDOMServer.renderToStaticMarkup(
            <PrintBusinessCreditReport
                bCreditReportData={props.bCreditReportData}
                reportObject={props.reportObject}
                requestBusinessCreditReport={props.requestBusinessCreditReport}
                creditProvider={props.creditProvider}
            />
        );
        themeCSS = "";
        let printWindow = window.open("", "_blank", "width=600,height=800 scrollbars");
        if (printWindow != null) {
            printWindow.document.head.innerHTML =
                '<title>Credit Report</title><link href="' +
                decodeURIComponent(encodeURIComponent(window.location.origin)) +
                '/app/css/_application/application.css" rel="stylesheet" /> <link rel="stylesheet" href="https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/1.3.0/css/line-awesome.min.css"/>';
            printWindow.document.body.innerHTML = htmlMarkup;
            printWindow.focus();
            setTimeout(function () {
                if (printWindow != null) {
                    printWindow.print();
                }
            }, 2000);
        }
    };

    const orderNewBusinesCreditReport = () => {
        setLoading(true);
        services.getNewBusinessCreditReport(null, props.creditProvider).then((data) => {
            props.requestBusinessCreditReport();
            setLoading(false);
        });
    };
    const { t: tLang, i18n: i18nLang } = useTranslation();

    return (
        <React.Fragment>
            <div className="row" id="content">
                <div className={`col-xs ${loading ? "loading" : ""}`}>
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="file-invoice" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{props.creditProvider === "DUNBRADSTREET" ? "Business Credit Report" : "Credit Summary"}</h2>
                                </div>
                            </div>
                            <div className="box-helper">
                                {props.isPrintAndRefreshButtonShow && (
                                    <div className="row full-width between-xs">
                                        <div className="col-xs col-gutter-vertical flex-grow-null">
                                            <ul className="list-reset margin-bottom-s credit-report-dates">
                                                <li>
                                                    <em className="las la-calendar-day icon-inline"></em>{" "}
                                                    <strong>{props.creditProvider === "CREDITSAFE" ? "Creditsafe" : "Dun & Bradstreet"} Last Refreshed: </strong>
                                                    {props.bCreditReportData?.CreatedDate &&
                                                        getFormattedDate(i18nService.get("Country"), props.bCreditReportData?.CreatedDate)}
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-xs col-gutter-vertical flex-grow-null">
                                            <ul className="list-reset list-inline">
                                                <li>
                                                    <button
                                                        type="button"
                                                        className="btn-default btn-secondary-outline"
                                                        onClick={() => {
                                                            printCreditReport();
                                                            window.addToDataLayer({ event: "Print Business Credit Summary Report" });
                                                        }}
                                                    >
                                                        <span className="btn-icon">
                                                            <RenderIcons iconName="print" />
                                                        </span>
                                                        <span className="btn-text">Print Report</span>
                                                    </button>
                                                </li>
                                                <li className="margin-left-xs">
                                                    <button type="button" className="btn-default btn-primary" onClick={() => orderNewBusinesCreditReport()}>
                                                        <span className="btn-text">Refresh Credit Report</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="box-actions"></div>
                        </div>
                        <div className="box-content">
                            {props.creditProvider === "DUNBRADSTREET" && (
                                <React.Fragment>
                                    <div className="drawer-container">
                                        <BCreditRiskTracker
                                            reportObject={props.reportObject}
                                            showDetails={false}
                                            view={"report"}
                                            isFromDailog={props.isFromDailog}
                                        />
                                    </div>
                                    <div className="drawer-container">
                                        <PaydexScore reportObject={props.reportObject} />
                                    </div>
                                </React.Fragment>
                            )}
                            <div className="drawer-container">
                                <div className="drawer-header">
                                    <button
                                        aria-expanded="true"
                                        className="btn-default btn-toggle btn-drawer"
                                        id="btn-report-summary"
                                        onClick={() => toggle("report-summary", "btn-report-summary")}
                                    >
                                        <span className="btn-toggle-status sr-only">Hide</span>
                                        <span className="btn-text">Report Summary</span>
                                    </button>
                                </div>

                                <div className="drawer-content" id="report-summary" style={{ display: "block" }} aria-hidden="false">
                                    <h3 className="sr-only">Report Summary</h3>

                                    <div className="row full-width between-xs margin-bottom-l payment-table-header">
                                        <div className="col-xs flex-grow-null">
                                            <h4 className="content-sub-title">{props.reportObject?.businessCompanyReport?.company_details?.company_name}</h4>
                                        </div>
                                    </div>

                                    <div className="table-container scroll">
                                        <table className="m-table-generic">
                                            <caption className="sr-only">Report Summary Table</caption>
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        <span className="sr-only">Item</span>
                                                    </th>
                                                    <th scope="col">
                                                        Current (
                                                        {props.bCreditReportData?.uiData?.currentDate &&
                                                            getFormattedDate(i18nService.get("Country"), props.bCreditReportData?.uiData?.currentDate)}
                                                        )
                                                    </th>
                                                    {showPreviousReport && (
                                                        <th scope="col">
                                                            Previous (
                                                            {props.bCreditReportData?.uiData?.previousDate
                                                                ? getFormattedDate(i18nService.get("Country"), props.bCreditReportData?.uiData?.previousDate)
                                                                : getFormattedDate(
                                                                      i18nService.get("Country"),
                                                                      props.bCreditReportData?.uiData?.currentDate
                                                                          ? props.bCreditReportData?.uiData?.currentDate
                                                                          : ""
                                                                  )}
                                                            )
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row" className="table-label">
                                                        {tLang("dashboard.creditScore.title")}
                                                    </th>
                                                    <td>{props.reportObject?.businessCompanyReport?.credit_score_and_limit?.current_score}</td>
                                                    {showPreviousReport && (
                                                        <td>{props.reportObject?.businessCompanyReport?.credit_score_and_limit?.previous_score}</td>
                                                    )}
                                                </tr>
                                                <tr>
                                                    <th scope="row" className="table-label">
                                                        Recommended Credit Limit
                                                    </th>
                                                    <td>{props.reportObject?.businessCompanyReport?.credit_score_and_limit?.current_recommended_credit_limit}</td>
                                                    {showPreviousReport && (
                                                        <td>
                                                            {props.reportObject?.businessCompanyReport?.credit_score_and_limit?.previous_recommended_credit_limit}
                                                        </td>
                                                    )}
                                                </tr>
                                                {props.creditProvider !== "DUNBRADSTREET" && (
                                                    <tr>
                                                        <th scope="row" className="table-label">
                                                            Days Beyond Term (DBT)
                                                        </th>
                                                        <td>
                                                            {props.reportObject?.businessCompanyReport?.monthly_dbt_trends?.[0].days_beyond_terms
                                                                ? props.reportObject?.businessCompanyReport?.monthly_dbt_trends?.[0].days_beyond_terms
                                                                : "--"}
                                                        </td>
                                                        {showPreviousReport && (
                                                            <td>
                                                                {props.reportObject?.businessCompanyReport?.previous_monthly_dbt_trends?.[0].days_beyond_terms
                                                                    ? props.reportObject?.businessCompanyReport?.previous_monthly_dbt_trends?.[0].days_beyond_terms
                                                                    : "--"}
                                                            </td>
                                                        )}
                                                    </tr>
                                                )}

                                                {props.creditProvider === "DUNBRADSTREET" && (
                                                    <tr>
                                                        <th scope="row" className="table-label">
                                                            PAYDEX® Score
                                                        </th>
                                                        <td>
                                                            {props.reportObject?.businessCompanyReport?.credit_score_and_limit?.paydex_score
                                                                ? props.reportObject?.businessCompanyReport?.credit_score_and_limit?.paydex_score
                                                                : "--"}
                                                        </td>
                                                        {showPreviousReport && (
                                                            <td>
                                                                {props.reportObject?.businessCompanyReport?.credit_score_and_limit?.previous_paydex_score
                                                                    ? props.reportObject?.businessCompanyReport?.credit_score_and_limit?.previous_paydex_score
                                                                    : "--"}
                                                            </td>
                                                        )}
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="margin-top-xl"></div>

                                    <CreditSummaryReportInquery
                                        bCreditReportData={props.bCreditReportData}
                                        reportObject={props.reportObject}
                                        showAsAccordion={props.isForPrinting}
                                    />

                                    <CreditSummaryCommentary reportObject={props.reportObject} showAsAccordion={props.isForPrinting} />
                                </div>
                            </div>

                            <CreditSummaryAccordions
                                bCreditReportData={props.bCreditReportData}
                                reportObject={props.reportObject}
                                showAsAccordion={showAsAccordion}
                                creditProvider={props.creditProvider}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditSummary;
